export default __webpack_public_path__ + "static/media/franchise.b514e4bc.png";